export default [
    {
        path: '/supervision/ia_analysis',
        name: 'ia-analysis',
        meta: {
            layout: 'session'
        },
        component: () => import('VIEWS/supervision/IAAnalysis.vue')
    }
]